import React from "react";

import InvestDashboardProductContent from "../../components/InvestDashboardProductContent";
import Header from "../../layouts/Header";
import GradientBackground from "../../layouts/GradientBackground";
import { useAuth0 } from "@auth0/auth0-react";
import { PoweroffOutlined } from "@ant-design/icons";
import { useState } from "react";
import ConfirmationDetails from "../../components/ConfirmQuoteModal";
import { useLocation } from "react-router-dom";
export default function InvestProductDash({}) {
  const location = useLocation();

  const data = location?.state?.productType;
  const prodId = location?.state?.productId;
  const ledgerId = location?.state?.ledgerId;
  const applicationId = location?.state?.applicationId;

  console.log("ledgerId", ledgerId);

  const { logout } = useAuth0();
  //const { productType } = route.params;

  const handleLogout = () => {
    localStorage.clear();

    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <GradientBackground>
      <Header />

      <InvestDashboardProductContent
        productType={data}
        productId={prodId}
        ledgerId={ledgerId}
        applicationId={applicationId}
      />
    </GradientBackground>
  );
}
